import axios from "axios";
import ConstantList from "../appConfig";
import HttpService from "./HttpService";

const API_PATH = ConstantList.API_EN_POINT_CRM + "/customer-ticket";
const API_PATH_1 = ConstantList.API_EN_POINT_CRM + "/customer-ticket-rating";
const API_PATH_2 = ConstantList.API_EN_POINT_CRM + "/lead-reaction";
const API_PATH_CRM = ConstantList.API_EN_POINT_CRM;
export const pagingReviewFeedback = (searchObject) => {
  return HttpService.getAxiosClient().post(API_PATH_1 + "/page", searchObject);
};
export const pagingComplaintTicket = (searchObject) => {
  return HttpService.getAxiosClient().post(API_PATH + "/search", searchObject);
};

export const pagingLeadReaction = (searchObject) =>
  HttpService.getAxiosClient().post(API_PATH_2 + "/paging", searchObject);
export const syncClientList = (searchObject) =>
  axios.post(API_PATH_CRM + "/emr-sync/sync-client-list", searchObject);
